import IBlockEditor from "@/editor/blockEditorInterface";
import Block from "@/editor/block";

export default class BlockFactory {
  private static readonly _instance: BlockFactory = new BlockFactory();
  private readonly _classes: Map<string, any> = new Map<string, any>();

  static getInstance(): BlockFactory {
    return this._instance;
  }

  register(name: string, clazz: any, namespace: string = ""): void {
    this._classes.set(this.getBlockKey(namespace, name), clazz);
  }

  getClass(name: string, namespace: string = ""): any {
    return this._classes.get(this.getBlockKey(namespace, name));
  }

  create(json: any, editor: IBlockEditor, namespace: string = ""): Block {
    const clazz = BlockFactory.getInstance().getClass(json.type, namespace);

    if (!clazz) {
      throw new Error(`Unknown block type: ${json.type}`);
    }

    return new clazz(json, editor);
  }

  createMany(jsonArray: any[], editor: IBlockEditor, namespace: string = ""): Block[] {
    return jsonArray.filter((it: any) => !!it.type).map((it: any) => this.create(it, editor, namespace));
  }

  private getBlockKey(namespace: string, name: string): string {
    return namespace + ":" + name;
  }
}
